import { useMutation } from "urql";
import { graphql } from "@acto/gql";
import { MeetingPrepCardHideReason } from "@acto/gql/graphql";
import { useCallback, useState } from "react";

const HideMeetingPrepCardMutation = graphql(`
  mutation HideMeetingPrepCard($input: HideMeetingPrepCardInput!) {
    hideMeetingPrepCard(input: $input) {
      id
      __typename
      clientId
      prepSessionId
      cardKey
      cardType
      reason
    }
  }
`);

export interface HideMeetingPrepCardInput {
  clientId: string;
  prepSessionId: string;
  cardKey: string;
  cardType: string;
  reason: MeetingPrepCardHideReason;
  reasonText: string;
  /** Serialized TalkingPoint JSON snapshot as rendered. */
  card?: string;
}

export function useHideMeetingPrepCard() {
  const [result, hideMeetingPrepCardMutation] = useMutation(HideMeetingPrepCardMutation);
  const [error, setError] = useState<Error | null>(null);

  const hideMeetingPrepCard = useCallback(
    async (input: HideMeetingPrepCardInput) => {
      try {
        const response = await hideMeetingPrepCardMutation({ input });
        if (response.error) {
          throw response.error;
        }
        setError(null);
        return response.data?.hideMeetingPrepCard;
      } catch (err: unknown) {
        if (err instanceof Error) {
          setError(err);
          return null;
        } else {
          throw err;
        }
      }
    },
    [hideMeetingPrepCardMutation],
  );

  return { hideMeetingPrepCard, result, error };
}
